import seedrandom from 'seedrandom'
import RandomUtils from '@/utils/randomUtils'

const avatarStyle =
{
    topType: ['NoHair', 'Eyepatch', 'Hat', 'Hijab', 'Turban', 'WinterHat1', 'WinterHat2', 'WinterHat3', 'WinterHat4', 'LongHairBigHair', 'LongHairBob', 'LongHairBun', 'LongHairCurly', 'LongHairCurvy', 'LongHairDreads', 'LongHairFrida', 'LongHairFro', 'LongHairFroBand', 'LongHairNotTooLong', 'LongHairShavedSides', 'LongHairMiaWallace', 'LongHairStraight', 'LongHairStraight2', 'LongHairStraightStrand', 'ShortHairDreads01', 'ShortHairDreads02', 'ShortHairFrizzle', 'ShortHairShaggyMullet', 'ShortHairShortCurly', 'ShortHairShortFlat', 'ShortHairShortRound', 'ShortHairShortWaved', 'ShortHairSides', 'ShortHairTheCaesar', 'ShortHairTheCaesarSidePart'],
    accessoriesType: ['Blank', 'Kurt', 'Prescription01', 'Prescription02', 'Round', 'Sunglasses', 'Wayfarers'],
    hairColor: ['Auburn','Black','Blonde','BlondeGolden','Brown','BrownDark','PastelPink','Platinum','Red','SilverGray'],
    facialHairType: ['Blank','BeardMedium','BeardLight','BeardMagestic','MoustacheFancy','MoustacheMagnum'],
    facialHairColor: ['Auburn','Black','Blonde','BlondeGolden','Brown','BrownDark','Platinum','Red'],
    clotheType: ['BlazerShirt','BlazerSweater','CollarSweater','GraphicShirt','Hoodie','Overall','ShirtCrewNeck','ShirtScoopNeck','ShirtVNeck'],
    clotheColor: ['Black','Blue01','Blue02','Blue03','Gray01','Gray02','Heather','PastelBlue','PastelGreen','PastelOrange','PastelRed','PastelYellow','Pink','Red','White'],
    eyeType: ['Close','Cry','Default','Dizzy','EyeRoll','Happy','Hearts','Side','Squint','Surprised','Wink','WinkWacky'],
    eyebrowType: ['Angry','AngryNatural','Default','DefaultNatural','FlatNatural','RaisedExcited','RaisedExcitedNatural','SadConcerned','SadConcernedNatural','UnibrowNatural','UpDown','UpDownNatural'],
    mouthType: ['Concerned','Default','Disbelief','Eating','Grimace','Sad','ScreamOpen','Serious','Smile','Tongue','Twinkle','Vomit'],
    skinColor: ['Tanned','Yellow','Pale','Light','Brown','DarkBrown','Black']
}

function generateRandomAvatarUrl (seed, isCircle)
{
    if (isCircle != false) isCircle = true

    const rand = seedrandom(seed)
    var queryString = 'avatarStyle=' + (isCircle ? 'Circle' : 'Transparent')
    
    for (let [name, values] of Object.entries(avatarStyle))
    {
        queryString += `&${name}=${values[RandomUtils.getRandomInt(0, values.length - 1, rand())]}`
    }

    return `https://avataaars.io/?${queryString}`
}

export default { generateRandomAvatarUrl }


// WEBPACK FOOTER //
// ./src/utils/avatarUtils.js